<template>

  <div>
    <v-flex class="data-noBoxShadow data-imgbgcenter mb-5" height="100vh">

      <!-- titulo y botonera principal -->
      <v-card-title class="buttonBar py-0 data-firstContent pt-4 pl-4">
        <!-- titulo pagina -->
        <v-btn flat icon @click.stop="volver()" :title="this.$t('volver') ">
          <v-icon dark>arrow_back</v-icon>
        </v-btn>
        <div class="data-title">
          {{this.$t('miCuenta')}}
        </div>
      </v-card-title>
      <!-- tabla visualización datos -->
      <v-layout row wrap class="pt-3 px-4 pb-5 data-principalContent">
        <v-card class="elevation-6" width="100%">
          <v-layout row wrap>
            <v-flex xs12 md6 pa-4>
              <v-flex xs12 class="loginWelcome">Mis datos</v-flex>
              <v-layout row wrap mt-4>
                <v-flex xs12 sm4>
                  <v-avatar :tile="tile" :size="170" color="grey lighten-3">
                    <i aria-hidden="true" class="v-icon material-icons" style="font-size: 6em">person</i>
                  </v-avatar>
                </v-flex>
                <v-flex xs11 sm8>
                  <v-flex pl-4>
                    <v-flex xs12 sm10>
                      <v-text-field value="Lucas" label="Nombre" disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm10>
                      <v-text-field value="Moura" label="Primer Apellido" disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm10>
                      <v-text-field value="De Miguel" label="Segundo Apellido" disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm10>
                      <v-text-field value="lmourademi@datadec.es" label="Email" disabled></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm10>
                      <v-text-field value="Rapresentante" label="Tipo Usuario" disabled></v-text-field>
                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md6 pa-4>
              <v-flex xs12 class="loginWelcome">Mis clientes</v-flex>
              <v-flex mt-3>Selecciona el cliente con el cual quieres operar en la plataforma</v-flex>
              <v-list class="data-lis data-gbGreyLight data-tableMisClientes mt-4">
                <v-container style="max-height: 400px;" class="scroll-y" id="scroll-target">
                  <div class="px-5">
                    <v-text-field class="data-colorcorp1 mt-4" append-icon="search" v-model="search" :label="this.$t('buscar')"></v-text-field>
                  </div>
                  <v-data-table :headers="headers" :items="clientes" hide-actions>
                    <template slot="items" slot-scope="props" class="px-3">
                      <tr class="data-gbGreyLight" :active="props.selected" @click="props.selected = !props.selected">
                        <td class="data-gbGreyLight">
                          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td class="data-gbGreyLight">{{ props.item.codigoCliente }}</td>
                        <td>{{ props.item.nombreCliente }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-container>
              </v-list>
              <v-flex text-xs-right mt-3>
                <v-btn class="data-bntStandardThin data-bgPrimaryColor white--text" flat @click="seleccionaEmpresa();menu=false">{{this.$t('aceptar')}}</v-btn>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card>
      </v-layout>
    </v-flex>
    <v-container fluid class="data-footer">
      <v-flex class="pa-4 white--text text-xs-center">Powered by DATACENTER ONLINE · 2018 · Todos los derechos reservados</v-flex>
    </v-container>
    <!-- informe -->
    <v-dialog v-model="mostrarDialogInforme" persistent width="900px">
      <ShpReimpresionFacturas></ShpReimpresionFacturas>
    </v-dialog>
  </div>
</template>

<script>

export default {

  data () {
    return {
      modulo: this.$store.getters.getModulo,
      headers: [{},
        {
          text: 'Codigo',
          align: 'left',
          sortable: false,
          value: 'name'
        }, {
          text: 'Cliente', value: 'calories'
        }],
      clientes: [{
        codigoCliente: '2345',
        nombreCliente: 'Carrefour'
      },
      {
        codigoCliente: '27856',
        nombreCliente: 'Todomuebles'
      },
      {
        codigoCliente: '45657',
        nombreCliente: 'Muebles Tresillos'
      },
      {
        codigoCliente: '3487',
        nombreCliente: 'Lineajove'
      },
      {
        codigoCliente: '7987',
        nombreCliente: 'Muebles Rivadulla'
      }
      ],
      muestraSelecccionCliente: this.modulo === 'TIENDA',
      menu: false,
      search: ''
    }
  },
  methods: {
    volver () {
      this.$router.go(-1)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Catalogo/ShpMiCuenta.vue